import { Resource } from "react-admin";
import RolesIcon from "@material-ui/icons/Security";
import React from "react";
import { POLICY_ROLE_MAPPINGS } from "../../common/rolesManagement";
import PermissionDenied from "../../components/PermissionDenied";
import List from "./List";
import Edit from "./Edit";

export default permissions => (
    <Resource
        name="role-mappings"
        icon={RolesIcon}
        list={
            permissions && permissions.includes(POLICY_ROLE_MAPPINGS.READ)
                ? List
                : PermissionDenied
        }
        edit={Edit}
    />
);



// WEBPACK FOOTER //
// ./src/resources/RoleMappings/index.js